/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Forbidden_PermissionInputs */

const vi_error_forbidden_permission = /** @type {(inputs: Error_Forbidden_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoá API đối tác này chưa được cấp quyền xem dữ liệu này. Vào màn API Key, bấm Sửa quyền để cấp thêm.`)
};

/**

* @param {Error_Forbidden_PermissionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_forbidden_permission = /** @type {((inputs?: Error_Forbidden_PermissionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Forbidden_PermissionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_forbidden_permission(inputs)
});